import { MicroButton } from "@studio3t/generic-components";
import styled from "styled-components";

/**
 * Shared close control for modal headers — the design-system MicroButton (14px
 * close icon, per Figma node 13421-57415) pinned to the header's top-right
 * corner. `transform` centres the button on the (top, right) point, so pass the
 * header's top/right padding as $top/$right and the icon lands exactly on the
 * padding corner (matching the Figma close placement). The host ModalHeader
 * must be `position: relative`.
 */
export const ModalCloseButton = styled(MicroButton)<{
  $top: number;
  $right: number;
}>`
  position: absolute;
  top: ${(p) => p.$top}px;
  right: ${(p) => p.$right}px;
  transform: translate(50%, -50%);
`;
